import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import type { SubAgentTodo } from "../../../../model/block.types";

/**
 * Generic renderer for a sub-agent's TODO checklist (`write_todos`-style CUSTOM events —
 * `deep_analysis_todo_update`, `style_todo_update`, and any future `*_todo_update` event, all
 * sharing the same `{ todos: SubAgentTodo[] }` payload). Purely presentational: reused both
 * nested inside `TaskListCardComponent` (pipeline sub-agent activity) and inside
 * `TodoListCardComponent` (standalone conversational turn), so the checklist looks identical
 * in either context.
 */
@Component({
  selector: "app-todo-list",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon],
  templateUrl: "./todo-list.component.html",
  styleUrl: "./todo-list.component.scss",
})
export class TodoListComponent {
  readonly todos = input.required<SubAgentTodo[]>();

  readonly title = input<string>("To-do list");
}
